export const WEB_WORKER_VERSION = '0.0.9';
export const WEB_WORKER_NAME = 'calling';